import { Component, OnInit, trigger, state, animate, transition, style } from '@angular/core';

import { WpService } from '../service/wp.service'

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  animations: [
    trigger('slideDown', [
      state('false', style({height: '4.5em'})),
      state('true', style({height: '*'})),
      transition('* => *', animate('300ms'))
    ])
  ]
})
export class MainComponent implements OnInit {
  data = undefined;
  course = undefined;
  blog = undefined;
  info = undefined;

  constructor(private wp: WpService) {
    wp.get('main').subscribe(
      data => {
        this.data = data;
        for(let course of data.main){
          course.post_content = course.post_content.substring(0, 800);
        }
        this.course = data.sidebar.course;
        this.course.start = new Date(this.course.start)
        this.course.expanded = false;
        this.blog = data.sidebar.blog;
        this.info = data.sidebar.info
      },
      error =>
      console.log(error)
    )
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/leonhard/Projekte/braungardt/angular/src/app/main/main.component.ts